export enum MilitaryRequests {
	DDRequested = 'ddRequested',
	Honors = 'honors',
	MilitaryMarker = 'militaryMarker',
	FlagDraped = 'flagDraped',
	FlagFolded = 'flagFolded',
	VeteransCemetery = 'veteransCemetery',
	PresidentialMemorialCertificate = 'presidentialMemorialCertificate',
}
